<section class="content">
  <app-breadcrumbs type="settings"></app-breadcrumbs>
  <div class="card">
    <div class="card-tabs">
      <ul class="tabs" role="tablist">
        <li class="tabs-item" routerLinkActive="active">
          <a routerLink="/settings/user">
            User settings
          </a>
        </li>
        <li class="tabs-item" routerLinkActive="active">
          <a routerLink="/settings/subscription">
            Subscription settings
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <router-outlet></router-outlet>
    </div>
  </div>
</section>



